export default __webpack_public_path__ + "static/media/t2.min.19d5852b.png";